<div class="my-4" *ngIf="questions">
  <h2
    class="text-text font-bold text-lg text-center mt-8"
    [innerHTML]="customerExperience
      ? resource.cross_selling.title_w
      :  isPartner
          ? resource.cross_selling.title_c_partner.format(contrat_ref)
          : resource.cross_selling.title_c.format(contrat_ref)"></h2>
  <form [formGroup]="form" *ngIf="!isPartner">
    <div *ngIf="questions.length > 0">
      <div *ngFor="let question of questions; let i = index" class="space-y-5">
        <app-question [question]="question"></app-question>
        <app-toggle-question
          [responses]="question.responseVMs ?? []"
          [reduced]="true"
          formControlName="question-{{ question.id }}"
        ></app-toggle-question>
      </div>
    </div>

    <div class="w-full md:col-span-2 consent space-y-4 my-10">
      <div class="flex items-center justify-items">
        <div class="basis-5/6 mr-1">
          <p class="text-[16px]" id="marketing-email-label" [innerHTML]="resource.consent.marketing_email"></p>
        </div>
        <div class="basis-1/6 text-right">
          <p-inputSwitch
          formControlName="marketing_email_opposition"
          [ariaLabelledBy]="'marketing-email-label'"
          [ariaLabel]="resource.consent.marketing_email"></p-inputSwitch>
        </div>
      </div>
      <div class="flex items-center justify-items">
        <div class="basis-5/6 mr-1">
          <p class="text-[16px]" id="marketing-phone-label" [innerHTML]="resource.consent.marketing_phone"></p>
        </div>
        <div class="basis-1/6 text-right">
          <p-inputSwitch
            formControlName="marketing_phone_consent"
            [ariaLabelledBy]="'marketing-phone-label'"
            [ariaLabel]="resource.consent.marketing_phone"></p-inputSwitch>
        </div>
      </div>
    </div>

     <div>
      <p
        class="p-error text-center mb-4"
        *ngIf="form.invalid && triedSubmit"
        [innerHTML]="resource.error.crossSelling"></p>
    </div>
    <button
      *ngIf="!hideSubmitButton"
      pButton
      type="button"
      class="button-NS w-full"
      title="{{ resource.form.validate }}"
      [label]="resource.form.validate"
      [loading]="isLoading"
      [disabled]="isLoading"
      (click)="nextStep()"
    ></button>
    <div *ngIf="hideSubmitButton" class="button-noline w-full text-success" [innerHTML]="resource.cross_selling.answers_saved">
    </div>
  </form>
</div>

<p-dialog
  [header]="resource.error.oups"
  [(visible)]="displayError"
  [modal]="true"
  [style]="{ width: '330px', margin: '1rem' }"
  [closable]="true"
  [baseZIndex]="10000"
>
  <p class="text-P my-5 whitespace-pre-line">
    {{ resource.error.api }}
  </p>
</p-dialog>
